var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.874,
    height: 37.343,
    viewBox: "0 0 37.874 37.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "go6qv82dna",
    x: 0,
    y: 0,
    width: 43.57,
    height: 45.532,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00ebff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3439",
    style: {
      filter: "url(#go6qv82dna)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3438"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3436"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 246",
    transform: "translate(9.937 10.171)",
    style: {
      stroke: "#8ff4f6",
      fill: "none",
      strokeWidth: 3
    },
    d: "m0 0 10 8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 248",
    transform: "translate(17.937 10.171)",
    style: {
      stroke: "#8ff4f6",
      fill: "none",
      strokeWidth: 3
    },
    d: "M10 0 0 8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 247",
    transform: "translate(9.937 19.171)",
    style: {
      stroke: "#8ff4f6",
      fill: "none",
      strokeWidth: 3
    },
    d: "m0 0 10 8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 249",
    transform: "translate(17.937 19.171)",
    style: {
      stroke: "#8ff4f6",
      fill: "none",
      strokeWidth: 3
    },
    d: "M10 0 0 8"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3437"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3436"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 246",
    transform: "translate(9.937 10.171)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeWidth: 3
    },
    d: "m0 0 10 8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 248",
    transform: "translate(17.937 10.171)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeWidth: 3
    },
    d: "M10 0 0 8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 247",
    transform: "translate(9.937 19.171)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeWidth: 3
    },
    d: "m0 0 10 8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 249",
    transform: "translate(17.937 19.171)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeWidth: 3
    },
    d: "M10 0 0 8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.d9c672307988f041e09e4097c5c9c0c2.svg";
export { ForwardRef as ReactComponent };